"use strict";

var _interopRequireDefault = require("/home/cej/Documents/VS_Code/MWeeB/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectSpread2 = _interopRequireDefault(require("/home/cej/Documents/VS_Code/MWeeB/nq-component/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var _classCallCheck2 = _interopRequireDefault(require("/home/cej/Documents/VS_Code/MWeeB/nq-component/node_modules/@babel/runtime/helpers/esm/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/home/cej/Documents/VS_Code/MWeeB/nq-component/node_modules/@babel/runtime/helpers/esm/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/home/cej/Documents/VS_Code/MWeeB/nq-component/node_modules/@babel/runtime/helpers/esm/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/home/cej/Documents/VS_Code/MWeeB/nq-component/node_modules/@babel/runtime/helpers/esm/inherits.js"));
var _react = _interopRequireDefault(require("react"));
var _classNames = _interopRequireDefault(require("../classNames"));
var _jsxFileName = "/home/cej/Documents/VS_Code/MWeeB/nq-component/src/OffCanvas/index.js";
var defaultProps = {
  show: false,
  touchHandleWidth: 23,
  dragToggleDistance: 30,
  onSetShow: function onSetShow() {},
  styles: {},
  defaultSidebarWidth: 0,
  className: "bg-dark"
};
var defaultStyles = {
  sidebar: {},
  overlay: {
    zIndex: 1,
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    opacity: 0,
    visibility: "hidden",
    transition: "opacity .3s ease-out, visibility .3s ease-out",
    backgroundColor: "rgba(0,0,0,.3)"
  },
  dragHandle: {
    zIndex: 2,
    position: "fixed",
    top: 0,
    bottom: 0
  }
};
var CANCEL_DISTANCE_ON_SCROLL = 20;
var OffCanvas = /*#__PURE__*/function (_React$Component) {
  function OffCanvas(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, OffCanvas);
    _this = (0, _callSuper2["default"])(this, OffCanvas, [props]);
    _this.state = {
      sidebarWidth: props.defaultSidebarWidth,
      touchIdentifier: null,
      touchStartX: null,
      touchCurrentX: null,
      dragSupported: false
    };
    _this.onTouchStart = _this.onTouchStart.bind(_this);
    _this.onTouchMove = _this.onTouchMove.bind(_this);
    _this.onTouchEnd = _this.onTouchEnd.bind(_this);
    _this.onScroll = _this.onScroll.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(OffCanvas, _React$Component);
  return (0, _createClass2["default"])(OffCanvas, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        dragSupported: typeof window === "object" && "ontouchstart" in window
      });
      this.saveSidebarWidth();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (!this.isTouching()) {
        this.saveSidebarWidth();
      }
    }
  }, {
    key: "onTouchStart",
    value: function onTouchStart(event) {
      if (!this.isTouching()) {
        var touch = event.targetTouches[0];
        this.setState({
          touchIdentifier: touch.identifier,
          touchStartX: touch.clientX,
          touchCurrentX: touch.clientX
        });
      }
    }
  }, {
    key: "onTouchMove",
    value: function onTouchMove(event) {
      if (this.isTouching()) {
        var touch = event.targetTouches[0];
        this.setState({
          touchCurrentX: touch.clientX
        });
      }
    }
  }, {
    key: "onTouchEnd",
    value: function onTouchEnd() {
      if (this.isTouching()) {
        // trigger a change to show if sidebar has been dragged beyond dragToggleDistance
        var percentage = this.getMovePercent();
        if (this.props.show && percentage < 100 - this.props.dragToggleDistance || !this.props.show && percentage > this.props.dragToggleDistance) {
          this.props.onSetShow(!this.props.show);
        }
        this.setState({
          touchIdentifier: null,
          touchStartX: null,
          touchCurrentX: null
        });
      }
    }
  }, {
    key: "onScroll",
    value: function onScroll() {
      if (this.isTouching() && this.inCancelDistanceOnScroll()) {
        this.setState({
          touchIdentifier: null,
          touchStartX: null,
          touchCurrentX: null
        });
      }
    }

    // True if the on going gesture X distance is less than the cancel distance
  }, {
    key: "inCancelDistanceOnScroll",
    value: function inCancelDistanceOnScroll() {
      return Math.abs(this.state.touchStartX - this.state.touchCurrentX) < CANCEL_DISTANCE_ON_SCROLL;
    }
  }, {
    key: "isTouching",
    value: function isTouching() {
      return this.state.touchIdentifier !== null;
    }
  }, {
    key: "overlayClicked",
    value: function overlayClicked() {
      if (this.props.show) {
        this.props.onSetShow(false);
      }
    }
  }, {
    key: "saveSidebarWidth",
    value: function saveSidebarWidth() {
      // set width if not equal to last
      var width = this.sidebar.offsetWidth;
      if (width !== this.state.sidebarWidth) {
        this.setState({
          sidebarWidth: width
        });
      }
    }
  }, {
    key: "setSidebarRef",
    value: function setSidebarRef(node) {
      this.sidebar = node;
    }
  }, {
    key: "getMovePercent",
    value: function getMovePercent() {
      var start = this.state.touchStartX;
      var width = this.state.sidebarWidth;
      var current = this.state.touchCurrentX;
      // if already show calculate the distance they moved
      // otherwise it will move from the edge of the sidebar
      if (this.props.show) {
        var delta = current - start; // delta touch
        var percent = (delta + width) / width;
        return percent * 100;
      }
      return Math.min(current / width * 100, 100);
    }
  }, {
    key: "render",
    value: function render() {
      var dragHandle;
      var dragHandleStyle = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, defaultStyles.dragHandle), this.props.styles.dragHandle);
      var sidebarStyle = (0, _objectSpread2["default"])({}, defaultStyles.sidebar);
      var overlayStyle = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, defaultStyles.overlay), this.props.styles.overlay);
      var useTouch = this.state.dragSupported;
      dragHandleStyle.width = this.props.touchHandleWidth;
      var sidebarProps = {};
      if (useTouch) {
        if (this.props.show) {
          sidebarProps.onTouchStart = this.onTouchStart;
          sidebarProps.onTouchMove = this.onTouchMove;
          sidebarProps.onTouchEnd = this.onTouchEnd;
          sidebarProps.onTouchCancel = this.onTouchEnd;
          sidebarProps.onScroll = this.onScroll;
          overlayStyle.opacity = 1;
          overlayStyle.visibility = "visible";
        } else {
          dragHandle = /*#__PURE__*/_react["default"].createElement("div", {
            style: dragHandleStyle,
            onTouchStart: this.onTouchStart,
            onTouchMove: this.onTouchMove,
            onTouchEnd: this.onTouchEnd,
            onTouchCancel: this.onTouchEnd,
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 168,
              columnNumber: 31
            }
          });
        }
      }
      var classes = (0, _classNames["default"])('offcanvas offcanvas-start sidebar-nav visible', this.props.className, this.props.show && 'show');
      var isTouching = this.isTouching();
      if (isTouching) {
        var percentage = this.getMovePercent();
        // translate from -100 to -0
        var translate = 100 - percentage;
        // slide show to what we dragged
        sidebarStyle.transform = "translateX(-".concat(translate, "%)");
        sidebarStyle.WebkitTransform = "translateX(-".concat(translate, "%)");
        // remove the transition when touching
        sidebarStyle.transition = 'transform 0s ease-in-out';
        // add backdrop
        overlayStyle.opacity = percentage / 100;
        overlayStyle.visibility = "visible";
      }
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", Object.assign({
        className: classes,
        style: sidebarStyle,
        ref: this.setSidebarRef.bind(this),
        "data-bs-backdrop": "true",
        "data-bs-scroll": "false",
        id: "offcanvas"
      }, sidebarProps, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 193,
          columnNumber: 13
        }
      }), this.props.children), dragHandle, /*#__PURE__*/_react["default"].createElement("div", {
        style: overlayStyle,
        onClick: this.overlayClicked.bind(this),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 204,
          columnNumber: 13
        }
      }));
    }
  }]);
}(_react["default"].Component);
OffCanvas.defaultProps = defaultProps;
var _default = exports["default"] = OffCanvas;